import styled from 'styled-components';

import {
  colorBlack900,
  colorSecondary,
  colorWhite,
  fontFamilySecondary,
} from 'styles';

export const Wrapper = styled.section`
  position: sticky;
  top: 0;
  z-index: 10;
  width: 100%;
  margin-top: 16px;
  padding: 0 16px;
  background: ${colorWhite};
  border-radius: 12px;
`;

export const TabsRow = styled.nav`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  min-height: 48px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

export const Tab = styled.button`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 48px;
  padding: 16px 0;
  margin: 0;
  border: 0;
  background: transparent;
  font-family: ${fontFamilySecondary};
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: ${({ $active }) => ($active ? colorSecondary : colorBlack900)};
  box-shadow: ${({ $active }) =>
    $active ? `inset 0 -3px 0 0 ${colorSecondary}` : 'none'};
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    opacity: 0.8;
  }
`;
